export function drawFilter(renderContext, node, callback) {
  const { context } = renderContext;
  const { scale } = renderContext.providers;
  const scaleValue = scale.scale;
  const render = () => {
    callback();
  };
  if (!node.filter) return render();

  const filter = node.filter;

  if (typeof filter === 'string' && filter.startsWith('seede-svg-filter')) {
    return render();
  }

  const preFilter = context.filter;
  // Scale filter values based on canvas DPR and scale value
  if (node.filter.includes('blur')) {
    const dpr = renderContext.dpr;
    // Extract blur value, scale it by both DPR and scale value, and replace in the filter string
    const scaledFilter = node.filter.replace(/blur\(([^)]+)\)/g, (match, value) => {
      const numValue = parseFloat(value);
      const unit = value.replace(/[\d.]/g, '');
      // Apply both DPR and inverse scale value to maintain visual consistency at different zoom levels
      return `blur(${numValue * dpr * scaleValue}${unit})`;
    });
    context.filter = scaledFilter;
  } else {
    context.filter = node.filter;
  }

  render();

  if (preFilter) {
    context.filter = preFilter;
  } else {
    resetBlur(renderContext);
  }
}

function resetBlur(renderContext) {
  const { context } = renderContext;
  context.filter = 'none';
}
